import '../../css/components/app.css';
import { LoggingIn } from './pages/logging-in';
import { useLoggingInStore } from '../pinia/store';
import { RoutePaths } from '../routing/route-paths';
import { PasswordSetUp } from './pages/password-set-up';
import { PageBase } from 'b24network.vue.page-base';
import { PasswordRestore } from './pages/password-restore';
import { mapState, mapWritableState } from 'ui.vue3.pinia';
import { LoggingInWithSso } from './pages/logging-in-with-sso';
import { SignInNoticesShowing } from './pages/sign-in-notices-showing';
import { SignInToPortal } from './pages/sign-in-to-portal';
import { ShowProfileListButton } from 'b24network.vue.sign-in-to-portal-form';

export const App = {
	name: 'LoggingInApp',

	components: {
		PageBase,
		LoggingIn,
		PasswordSetUp,
		PasswordRestore,
		LoggingInWithSso,
		SignInNoticesShowing,
		SignInToPortal,
		ShowProfileListButton,
	},

	computed: {
		...mapWritableState(useLoggingInStore, ['typeOfCaptchaOnPage']),

		...mapState(useLoggingInStore, [
			'legalLinks',
			'currentLanguageId',
			'currentSubScenario',
			'isPageContentHidden',
			'navigationButtonType',
			'isDesktopLogin',
		]),

		legalLinksForPage(): ?Object
		{
			const path = this.$router.currentRoute.value.path;

			return path === RoutePaths.SIGN_IN || path === RoutePaths.PASS_RESTORE
				// These pages render legal links in their own layout.
				? null
				: this.legalLinks
			;
		},

		helpDeskArticleId(): ?Number
		{
			switch (this.$router.currentRoute.value.path)
			{
				case RoutePaths.SIGN_IN:
					// Authorization FAQ
					return 12_331_664;

				case RoutePaths.PASS_RESTORE:
					// How to restore password
					return 17_729_224;

				case RoutePaths.PASS_SETUP:
					// How to set up a password for B24
					return 17_699_256;

				default:
					return null;
			}
		},
	},

	template: `
		<div class="b24net-sign-in-app">
			<PageBase
				:legal-links="legalLinksForPage"
				:current-language-id="currentLanguageId"
				:is-page-content-hidden="isPageContentHidden"
				:type-of-captcha-on-page="typeOfCaptchaOnPage"
				:navigation-button-type="navigationButtonType"
				:current-page-help-desk-article-id="helpDeskArticleId"
			>
				<RouterView />
			</PageBase>
		</div>
		<ShowProfileListButton v-if="isDesktopLogin" />
	`,
};
